/* This view does 2 things:
    1) either shows the details of an existing template; OR
    2) creates NEW template and redirects to the created page. */
import TopNavBar from "../../components/TopNavBar";
import BreadCrumbs from "../../components/BreadCrumbs";
import {useContext, useEffect, useRef, useState, useMemo, useCallback} from "react";
import AuthContext from "../../context/AuthContext";
import {IBlock} from "../../helpers/Interfaces";
import Button from "../../components/Button";
import QueryGroup from "../_subcomponents/QueryGroup";
import TargetValReturn from "../features/FeatMapReturnBlock";
import {Alert} from "@mui/material";
import {useParams, useNavigate} from "react-router-dom";
import TmplTools from "./TmplTools";
import LoadingBar from "../_subcomponents/LoadingBar";
import * as React from "react";


export default function TemplateMap() {

    let {user, logoutUser, authTokens, serverIP, userPermissions} = useContext(AuthContext)

    let {tmpl_pk} = useParams()

    const redirectIFNew = useNavigate()    // used to redirect after new template is created

    const postHeaders: any = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + String(authTokens.access)
    }

    // const [showSpinner, setShowSpinner] = useState<boolean>(false)

    const [mapInfo, setMapInfo] = useState<any>({})

    const [metaObj, setMetaObj] = useState<any>({
        mapType: 'template',
        taxName: 'Icecat',
        taxID: 1,
        tmplName: '',
        tmplUID: tmpl_pk
    })

    const dragElem = useRef(undefined)

    // const [loading, setLoading] = useState<boolean>(false)

    const [saveObj, setSaveObj] = useState<any>({
        code: null,
        reason: ''
    })

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../projects/1'},
        {'name': 'Templates', 'link': '../../templates/1'},
        {'name': tmpl_pk?.toString() === '0' ? 'New template' : 'Template detail', 'link': ''}
    ]

    const emptyCondObj: IBlock = {
        ID: 1,
        condition: 'and',
        rules: []
    }

    const [condObject, setCondObject] = useState<IBlock>(emptyCondObj)

    const [returnObj, setReturnObj] = useState<any>({
        actionType: 'none',
        joinDelim: '',
        transformRules: '',
        returnType: 'default',
        returnIfCond: ''
    })


    useEffect(() => {
        getTmplMap()
    }, [])


    let getTmplMap = async () => {
        // setShowSpinner(true)
        let response = await fetch(`${serverIP}/gettmplmap/`, {
            method: 'POST',
            headers: postHeaders,
            body: JSON.stringify({tmplUID: tmpl_pk}),
        })
        let data = await response.json()

        if (response.status === 200) {
            if (data.code === 200) {

                setMetaObj((prev: any) => {
                    return {...prev, tmplName: data.res.tmplName}
                })

                setReturnObj(data.res.mapObj.returnObj)
                setCondObject(data.res.mapObj.condObj)

                setMapInfo((prev: any) => {
                    return {...prev, mapDate: data.res.mapDate, mapUser: data.res.mapUser}
                })
            }
            // setShowSpinner(false)
        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }


    function handleSave() {
        // setLoading(true)

        fetch(`${serverIP}/tmplsave/`, {
            method: 'POST',
            headers: postHeaders,
            body: JSON.stringify({...metaObj, returnObj: returnObj, condObj: condObject, user: user.username}),
        }).then(res => res.json())
            .then((data) => {

                if (data.code === 201) {
                    // console.log('new PK:', data.newTmplUID)
                    setMetaObj((prev: any) => {
                        return {...metaObj, tmplUID: data.newTmplUID}
                    })
                }
                setSaveObj((prev: any) => {
                    return {...prev, code: data.code, reason: data.reason}
                })
            })
    }

    function handleMetaChange(value: any, name: any) {
        setMetaObj((prev: any) => {
            return {...prev, [name as keyof typeof prev]: value}
        })
    }

    useEffect(() => {
        if (saveObj.code) {
            // console.log('Effect -- Triggered by isSaved')
            const timeId = setTimeout(() => {
                if (saveObj.code === 201) {
                    window.history.replaceState(null, '', `../detail/${metaObj.tmplUID}`)
                    redirectIFNew(`../detail/${metaObj.tmplUID}`)
                }
                setSaveObj({code: null, reason: ''})
                // setLoading(false)
            }, 4000)

            return () => {
                clearTimeout(timeId)
            }
        }
    }, [saveObj.code])


    const readOnlyModeAlertStyle = {
        backgroundColor: "#fff5e6",
        color: "#804d00",
        fontSize: "0.84rem"
    }

    return (
        <>
            <TopNavBar user={user} logoutUser={logoutUser} projName="Generic Templates" topNavItems={[]}/>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            {!userPermissions.canEdit && <Alert icon={false} style={readOnlyModeAlertStyle}>This is a "read only" mode. Changes cannot be saved. </Alert>}

            {/*Spinner*/}
            {/*{showSpinner && <LoadingBar />}*/}

            {/* Alerts */}
            {saveObj.code === 201 && <Alert severity="success">The mapping has been saved!</Alert>}
            {saveObj.code === 104 && <Alert severity="error">{saveObj.reason}</Alert>}

            {/*{!showSpinner && */}
            <>
                <div className="tmpl-meta-tools-container">
                    <div className="tmpl-metadata">
                        <div className="field-label">Taxonomy name</div>
                        <input
                            name="tax_name"
                            type="text"
                            className="filter-input"
                            value={metaObj.taxName}
                            disabled
                            // onChange={(event) => handleMetaChange(event.target.value, event.target.name)}
                        />
                        <div className="field-label required">Template name</div>
                        <input
                            name="tmplName"
                            type="text"
                            className="filter-input"
                            onChange={(event) => handleMetaChange(event.target.value, event.target.name)}
                            value={metaObj.tmplName || ''}
                            style={{borderColor: saveObj.code === 104 || !metaObj.tmplName ? '#e15167' : ''}}
                            disabled={!userPermissions.canEdit}
                        />
                    </div>

                    <div className="tmpl-maptools">
                        <TmplTools
                            keyDataSet={metaObj}
                            mapInfo={mapInfo}
                        />
                    </div>
                </div>

                <TargetValReturn
                    returnObj={returnObj}
                    setReturnObj={setReturnObj}
                />

                <div>
                    <div className="top-group-container">
                        <QueryGroup
                            condObject={condObject}
                            setCondObject={setCondObject}
                            currentGroup={condObject}
                            level={1}
                            currentRules={condObject.rules}
                            index={0}
                            mapData={metaObj}
                            dragElem={dragElem}
                        />
                    </div>

                    {userPermissions.canEdit && <>
                        <div className="btn-save-container">
                            <Button
                                type={(condObject.rules?.length === 0 || !metaObj.tmplName) ? "secondary" : "primary"}
                                text="Save mapping"
                                onclick={handleSave}
                                disabled={condObject.rules?.length === 0 || saveObj.code === 104 || !metaObj.tmplName}
                            />
                        </div>
                    </>
                    }

                </div>
            </>
            {/*}*/}

        </>
    )
}
